module.exports = __webpack_public_path__ + "static/shoe-red-6bfae53852e048217c13b2469f7d6991.png";